import { UI_THEME_CHANGED } from "../actions/types";

/**
 * Reduces incoming settings actions to a new state
 *
 * @param {*} state
 * @param {*} action
 */
export default function settings(state = {}, action = {}) {
  switch (action.type) {
    /**
     * Changes the local theme
     */
    case UI_THEME_CHANGED:
      return { ...state, theme: action.theme };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/settings.js